import { Box, InputBase, Typography } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { postGroupSignUp } from "../../api/signin";
import DescriptionIcon from "../../assets/SVG/descriptionIcon";
import FemaleIcon from "../../assets/SVG/femaleIcon";
import LockIcon from "../../assets/SVG/lockIcon";
import MaleIcon from "../../assets/SVG/maleIcon";
import PhoneIcon2 from "../../assets/SVG/phoneIcon2";
import ProfileIcon from "../../assets/SVG/profileIcon";
import Vector from "../../assets/SVG/vector";
import CheckPhone from "./checkPhone";
import SelectInput from "./selectInput";

export default function SigninGroupForm({
  level,
  setLevel,
  setDataForm,
  dataForm,
  setDataCheckCode,
  dataCheckCode,
  update,
}) {
  const [sex, setSex] = useState(true);
  const [monthNumber, setMonthNumber] = useState();
  const [day, setDay] = useState(0);
  const [month, setMonth] = useState(0);
  const [year, setYear] = useState(0);
  const [universityYear, setUniversityYear] = useState(0);
  const [university, setUniversity] = useState(0);
  const [field, setField] = useState(0);
  const [inputField, setInputField] = useState("");
  const [endManageYear, setEndManageYear] = useState(0);
  const [showCheckPhone, setShowCheckPhone] = useState();
  const styleLabel = {
    color: "#2B2B2B",
    textAlign: "right",
    fontSize: "16px",
    fontWeight: "600",
  };
  useEffect(() => {
    if (sex) setDataForm({ ...dataForm, sex: "MALE" });
    if (!sex) setDataForm({ ...dataForm, sex: "FEMALE" });
  }, [sex]);
  // console.log(monthNumber);
  // console.log(month);
  useEffect(() => {
    if (day && month && year) {
      setDataForm({
        ...dataForm,
        birthDay: year + "/" + monthNumber + "/" + day,
      });
    }
  }, [day, month, year]);
  useEffect(() => {
    if (month === "فروردین") setMonthNumber("01");
    if (month === "اردیبهشت") setMonthNumber("02");
    if (month === "خرداد") setMonthNumber("03");
    if (month === "تیر") setMonthNumber("04");
    if (month === "مرداد") setMonthNumber("05");
    if (month === "شهریور") setMonthNumber("06");
    if (month === "مهر") setMonthNumber("07");
    if (month === "آبان") setMonthNumber("08");
    if (month === "آذر") setMonthNumber("09");
    if (month === "دی") setMonthNumber("10");
    if (month === "بهمن") setMonthNumber("11");
    if (month === "اسفند") setMonthNumber("12");
  }, [month]);
  useEffect(() => {
    if (dataForm?.birthDay.split("/", 3)[1] === "01") {
      setMonth("فروردین");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "02") {
      setMonth("اردیبهشت");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "03") {
      setMonth("خرداد");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "04") {
      setMonth("تیر");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "05") {
      setMonth("مرداد");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "06") {
      setMonth("شهریور");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "07") {
      setMonth("مهر");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "08") {
      setMonth("آبان");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "09") {
      setMonth("آذر");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "10") {
      setMonth("دی");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "11") {
      setMonth("بهمن");
    }
    if (dataForm?.birthDay.split("/", 3)[1] === "12") {
      setMonth("اسفند");
    }
    // console.log(dataForm?.birthDay.split("/", 3)[1]);
  }, [dataForm?.birthDay]);
  useEffect(() => {
    if (universityYear)
      setDataForm({ ...dataForm, universityYear: universityYear });
  }, [universityYear]);
  // useEffect(() => {
  //   if (university) setDataForm({ ...dataForm, university: university });
  // }, [university]);
  useEffect(() => {
    if (inputField !== "") {
      setDataForm({ ...dataForm, field: inputField });
    } else {
      if (field) setDataForm({ ...dataForm, field: field });
    }
  }, [inputField, field]);
  useEffect(() => {
    if (endManageYear)
      setDataForm({ ...dataForm, endManageYear: endManageYear });
  }, [endManageYear]);
  return (
    <Box display={"flex"} gap="100px" width="100%">
      <CheckPhone
        group
        setDataCheckCode={setDataCheckCode}
        dataCheckCode={dataCheckCode}
        setLevel={setLevel}
        show={showCheckPhone}
        setShow={setShowCheckPhone}
      />
      <Box width="70%">
        <Typography sx={styleLabel} display="flex">
          {"جنسیت/نام و نام خانوادگی"}
          <Typography color="red" mr="5px">
            *
          </Typography>
        </Typography>
        <Box display="flex" mt="5px" gap="3px">
          <Box
            onClick={() => {
              setSex(!sex);
            }}
            sx={{ cursor: "pointer", textAlign: "center" }}
            width="80px"
            py="3px"
            borderRadius="8px"
            boxShadow=" 0px 1px 2px 0px rgba(0, 0, 0, 0.08)"
            border="solid 1px var(--emr-borderInput)"
          >
            {sex && <MaleIcon />}
            {!sex && <FemaleIcon />}
          </Box>
          <InputBase
            onChange={(e) => setDataForm({ ...dataForm, name: e.target.value })}
            value={dataForm.name}
            placeholder="نام خود را کامل وارد نمایید."
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              width: "100%",
              px: "10px",
            }}
          />
        </Box>
        <Typography mt="10px" sx={styleLabel} display="flex">
          {"نام پدر"}
          <Typography color="red" mr="5px">
            *
          </Typography>
        </Typography>
        <Box
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            px: "10px",
            height: "53px",
            display: "flex",
            mt: "5px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <ProfileIcon />
          <InputBase
            onChange={(e) =>
              setDataForm({ ...dataForm, fatherName: e.target.value })
            }
            value={dataForm.fatherName}
            placeholder="نام پدر خود را وارد نمایید."
          />
        </Box>
        <Typography mt="10px" sx={styleLabel} display="flex">
          تاریخ تولد{" "}
          <Typography color="red" mr="5px">
            *
          </Typography>
        </Typography>
        <Box display="flex" gap="10px">
          <SelectInput
            value={dataForm?.birthDay.split("/", 3)[2] || day}
            setValue={setDay}
            width="150px"
            data={[
              ...[
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                10,
                11,
                12,
                13,
                14,
                15,
                16,
                17,
                18,
                19,
                20,
                21,
                22,
                23,
                24,
                25,
                26,
                27,
                28,
                29,
                30,
              ],
              ...[
                !month ||
                month === "فروردین" ||
                month === "اردیبهشت" ||
                month === "خرداد" ||
                month === "تیر" ||
                month === "مرداد" ||
                month === "شهریور"
                  ? 31
                  : null,
              ].filter((itr) => itr !== null),
            ]}
            placeholder="روز"
          />
          <SelectInput
            value={month}
            setValue={(newMonth) => {
              if (
                newMonth !== "فروردین" &&
                newMonth !== "اردیبهشت" &&
                newMonth !== "خرداد" &&
                newMonth !== "تیر" &&
                newMonth !== "مرداد" &&
                newMonth !== "شهریور" &&
                day &&
                day === 31
              )
                setDay(0);
              setMonth(newMonth);
            }}
            width="200px"
            data={[
              "فروردین",
              "اردیبهشت",
              "خرداد",
              "تیر",
              "مرداد",
              "شهریور",
              "مهر",
              "آبان",
              "آذر",
              "دی",
              "بهمن",
              "اسفند",
            ]}
            placeholder="ماه"
          />
          <SelectInput
            value={dataForm?.birthDay.split("/", 3)[0] || year}
            setValue={setYear}
            width="150px"
            data={[
              "1330",
              "1332",
              "1333",
              "1334",
              "1335",
              "1336",
              "1337",
              "1338",
              "1339",
              "1340",
              "1341",
              "1342",
              "1343",
              "1344",
              "1345",
              "1346",
              "1347",
              "1348",
              "1349",
              "1350",
              "1351",
              "1352",
              "1353",
              "1354",
              "1355",
              "1356",
              "1357",
              "1358",
              "1358",
              "1360",
              "1361",
              "1362",
              "1363",
              "1364",
              "1365",
              "1366",
              "1367",
              "1367",
              "1368",
              "1370",
              "1370",
              "1372",
              "1373",
              "1374",
              "1375",
              "1376",
              "1377",
              "1378",
              "1379",
              "1380",
              "1381",
              "1382",
              "1383",
              "1384",
              "1385",
              "1386",
              "1387",
              "1388",
              "1389",
              "1390",
              "1391",
            ]}
            placeholder="سال"
          />
        </Box>
        <Typography mt="10px" sx={styleLabel} display="flex">
          تحصیلات دانشجویی{" "}
          <Typography color="red" mr="5px">
            *
          </Typography>
        </Typography>
        <Box display="flex" gap="10px">
          <SelectInput
            value={dataForm?.universityYear || universityYear}
            setValue={setUniversityYear}
            width="110px"
            data={[
              "1350",
              "1351",
              "1352",
              "1353",
              "1354",
              "1355",
              "1356",
              "1357",
              "1358",
              "1358",
              "1360",
              "1361",
              "1362",
              "1363",
              "1364",
              "1365",
              "1366",
              "1367",
              "1367",
              "1368",
              "1370",
              "1370",
              "1372",
              "1373",
              "1374",
              "1375",
              "1376",
              "1377",
              "1378",
              "1379",
              "1380",
              "1381",
              "1382",
              "1383",
              "1384",
              "1385",
              "1386",
              "1387",
              "1388",
              "1389",
              "1390",
              "1391",
              "1392",
              "1393",
              "1394",
              "1395",
              "1396",
              "1397",
              "1398",
              "1399",
              "1400",
              "1401",
              "1402",
              "1403",
              "1404",
            ]}
            placeholder="سال"
          />
          <Box
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              pr: "10px",
              height: "44px",
              display: "flex",
              mt: "5px",
              boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              alignItems: "center",
              // width: "135px",
              // gap: "10px",
            }}
          >
            <InputBase
              onChange={(e) =>
                setDataForm({ ...dataForm, university: e.target.value })
              }
              value={dataForm.university}
              placeholder="دانشگاه"
            />
          </Box>
          <SelectInput
            value={field}
            setValue={setField}
            setValueInput={setInputField}
            valueInput={inputField}
            width="200px"
            data={[
              "پزشکی",
              "دندان پزشکی",
              "روانشناسی",
              "پرستاری",
              "مامایی",
              "فیزیوتراپی",
              "کاردرمانی",
              "داروسازی",
              "اتاق عمل",
              "علوم آزمایشگاهی",
              "بهداشت",
              "تغذیه",
              "همکاری در تیم رسانه",
              "شنوایی سنجی",
              "بینایی سنجی",
              "سایر",
            ]}
            placeholder="رشته"
          />
        </Box>
        <Typography mt="10px" sx={styleLabel} display="flex">
          {"کد ملی"}
          <Typography color="red" mr="5px">
            *
          </Typography>
        </Typography>
        <Box
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            px: "10px",
            height: "53px",
            display: "flex",
            mt: "5px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <DescriptionIcon />
          <InputBase
            inputProps={{ maxLength: 10 }}
            sx={{
              "&.MuiInputBase-root ": {
                width: "75% !important",
              },
            }}
            value={dataForm.nid}
            onChange={(e) =>
              setDataForm({
                ...dataForm,
                nid: e.target.value.replace(/\D/g, ""),
              })
            }
            placeholder="کد ملی خود را کامل وارد نمایید.."
          />
        </Box>
        <Typography mt="10px" sx={styleLabel} display="flex">
          {"تلفن همراه"}
          <Typography color="red" mr="5px">
            *
          </Typography>
        </Typography>
        <Box
          sx={{
            border: "solid 1px var(--emr-borderInput)",
            borderRadius: "8px",
            px: "10px",
            height: "53px",
            display: "flex",
            mt: "5px",
            boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            alignItems: "center",
            gap: "10px",
          }}
        >
          <PhoneIcon2 />
          <InputBase
            sx={{
              "&.MuiInputBase-root ": {
                width: "75% !important",
              },
            }}
            inputProps={{ maxLength: 11 }}
            onChange={(e) => {
              setDataForm({
                ...dataForm,
                phone: e.target.value.replace(/\D/g, ""),
              });
              setDataCheckCode({
                ...dataCheckCode,
                phone: e.target.value.replace(/\D/g, ""),
              });
            }}
            value={dataForm.phone}
            placeholder="شماره تلفن همراه خود را وارد نمایید."
          />
        </Box>
      </Box>
      <Box width="80%" display="grid" alignContent="space-between">
        <Box>
          <Typography display={"flex"} sx={styleLabel}>
            {"پایان دوره مسئولیت"}
            <Typography color="red" mr="5px">
              *
            </Typography>
          </Typography>
          <SelectInput
            value={dataForm?.endManageYear || endManageYear}
            setValue={setEndManageYear}
            width="450px"
            data={[
              "1400",
              "1401",
              "1402",
              "1403",
              "1404",
              "1405",
              "1406",
              "1407",
              "1408",
              "1409",
              "1410",
              "1411",
            ]}
            placeholder="سال"
          />
          <Typography mt="10px" sx={styleLabel}>
            {"شماره شناسنامه مسئول"}
          </Typography>
          <Box
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              px: "10px",
              height: "53px",
              display: "flex",
              mt: "5px",
              boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <DescriptionIcon />
            <InputBase
              sx={{ "&.MuiInputBase-root": { width: "100% !important" } }}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  cid: e.target.value.replace(/\D/g, ""),
                })
              }
              value={dataForm.cid}
              placeholder="شماره شناسنامه مسئول گروه را وارد نمایید."
            />
          </Box>
          <Typography mt="10px" sx={styleLabel}>
            {"رمز عبور"}
          </Typography>
          <Box
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              px: "10px",
              height: "53px",
              display: "flex",
              mt: "5px",
              boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LockIcon />
            <InputBase
              type={"password"}
              sx={{ "&.MuiInputBase-root": { width: "100% !important" } }}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  password: e.target.value,
                })
              }
              value={dataForm.password}
              placeholder="رمز عبور را وارد نمایید."
            />
          </Box>
          <Typography mt="10px" sx={styleLabel}>
            {"تکرار رمز عبور"}
          </Typography>
          <Box
            sx={{
              border: "solid 1px var(--emr-borderInput)",
              borderRadius: "8px",
              px: "10px",
              height: "53px",
              display: "flex",
              mt: "5px",
              boxShadow: " 0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <LockIcon />
            <InputBase
              type={"password"}
              sx={{ "&.MuiInputBase-root": { width: "100% !important" } }}
              onChange={(e) =>
                setDataForm({
                  ...dataForm,
                  passwordRepeat: e.target.value,
                })
              }
              value={dataForm.passwordRepeat}
              placeholder="تکرار رمز عبور را وارد نمایید."
            />
          </Box>
        </Box>
        <button
          style={{
            border: "none",
            height: "60px",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "var(--emr-primary)",
            boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.08)",
            padding: "12px 0px",
            marginTop: "20px",
            borderRadius: "8px",
          }}
          onClick={() => {
            if (update) {
              setLevel(2);
            } else if (
              dataForm.name !== "" &&
              dataForm.fatherName !== "" &&
              dataForm.birthDay !== "" &&
              dataForm.universityYear !== "" &&
              // dataForm.endManageYear !== "" &&
              dataForm.field !== "" &&
              dataForm.university !== "" &&
              dataForm.nid !== "" &&
              // dataForm.cid !== "" &&
              dataForm.phone !== ""
            ) {
              if (dataForm?.passwordRepeat !== dataForm?.password) {
                toast.error("رمزها یکسان نیست");
              } else {
                postGroupSignUp(dataForm)
                  .then((x) => {
                    setDataCheckCode({ ...dataCheckCode, token: x.token });
                    setShowCheckPhone(true);
                  })
                  .catch((err) => {
                    // toast.error(err.data)
                  });
              }
            } else {
              toast.error("فیلد های ضروری را پر کنید");
            }
          }}
        >
          <Typography fontSize="16px" color="white" ml="10px">
            مرحله بعد
          </Typography>
          <Vector color="white" />
        </button>
      </Box>
    </Box>
  );
}
